// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__rmDyb","emails":"CreateEditClinics_emails__3AXTr","emailTagLabel":"CreateEditClinics_emailTagLabel__2VQg0"};